document.addEventListener(
  'DOMContentLoaded',
  function () {
    // Function to handle click events
    function handleIconClick(event) {
      // Check if the clicked element has the 'data-enable-copy' attribute set to 'true'
      if (event.target.getAttribute('data-enable-copy') === 'true') {
        // Construct class name and HTML string
        var className = 'ioniq-icon__' + event.target.className
        var newDivHTML = '<div class="' + className + '"></div>'

        // Copy newDivHTML to clipboard
        navigator.clipboard
          .writeText(newDivHTML)
          .then(function () {
            // Alert the user that the HTML was copied
            alert('Icon copied: ' + newDivHTML)
          })
          .catch(function (err) {
            // This can happen if the user denies clipboard permissions or another error occurs
            console.error('Could not copy text to clipboard', err)
          })
      }
    }

    // Select all elements with the 'data-enable-copy="true"' attribute
    var copyEnabledElements = document.querySelectorAll('[data-enable-copy="true"]')

    // Attach the event listener to all these elements
    copyEnabledElements.forEach(function (element) {
      element.addEventListener('click', handleIconClick)
    })
  },
  false
)
